import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=1da4efab"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=1da4efab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports